"use client"

import { MenuDisplay } from './MenuDisplay';
import { MenuHoverEnter } from './MenuHoverEnter';
import { MenuHoverLeave } from './MenuHoverLeave';
import { MenuItem } from './MenuItem';
import { MenuOnClickClose } from './MenuOnClickClose';
import { MenuProvider } from './MenuProvider';
import { MenuToggle } from './MenuToggle';

type MenuCompound = typeof MenuProvider & {
  Display: typeof MenuDisplay;
  Toggle: typeof MenuToggle;
  HoverEnter: typeof MenuHoverEnter;
  HoverLeave: typeof MenuHoverLeave;
  OnClickClose: typeof MenuOnClickClose;
  Item: typeof MenuItem;
};

/**
 * provides management of the anchor element and open/close state of the PopoverDisplay
 * requires a <AnchorElement> to consume event handler
 *
 * @example
 * ```jsx
 *   <Menu>
 *     <Menu.Toggle>
 *       <Button>Dashboard</Button>
 *     </Menu.Toggle>
 *     <Menu.Display>
 *       <Menu.Item>
 *         <MenuItem>Profile</MenuItem>
 *       </Menu.Item>
 *       <Menu.Item>
 *         <MenuItem>My account</MenuItem>
 *       </Menu.Item>
 *       <Menu.Item>
 *         <MenuItem>Logout</MenuItem>
 *       </Menu.Item>
 *     </Menu.Display>
 *   </Menu>
 * ```
 */

export const Menu: MenuCompound = Object.assign( MenuProvider, {
  Display: MenuDisplay,
  Toggle: MenuToggle,
  OnClickClose: MenuOnClickClose,
  HoverToggle: MenuToggle,
  Item: MenuItem,
  HoverEnter: MenuHoverEnter,
  HoverLeave: MenuHoverLeave,
} );
